import React, { useState, useCallback, useEffect, Link } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { alert_error, alert_success } from "../AppContext.js";
import { Cookies } from '../index.js';
import axios from 'axios';
import { Helmet } from "react-helmet";
import io from 'socket.io-client';

const TaskList = () => {
    const [nutorder, setnutorder] = useState("Xác nhận");
    const [gtoken, setgtoken] = useState('');
    const [linklive, setlinklive] = useState('');
    const [nutxuly, setnutxuly] = useState(0);
    const [isDisabled, setIsDisabled] = useState(false);
    const tasks = [
        { id: 1, name: 'Máy tính bàn', gift: 'Mở' },
        { id: 2, name: 'Micro ip 1', gift: 'Mở' },
        { id: 3, name: 'Bộ chuyển đổi âm thanh 1', gift: 'Mở' },
        { id: 4, name: 'Bộ chuyển đổi âm thanh 2', gift: 'Mở' },
        // Thêm nhiệm vụ khác tại đây
    ];
    // Khai báo state để lưu trữ socket
    const [socket, setSocket] = useState(null);

    // Khai báo hàm sendUpdateLiveCommand
    const sendUpdateLiveCommand = (value) => {
        if (socket) {
            const jsonData = { chedo: 'updatelink', linklive: value };
            socket.emit('updatelive', jsonData);
        }
    };
    useEffect(() => {
        laydulieu();
    }, []);

    function laydulieu() {
        const myCookieValue = Cookies.get('apikey');
        axios.get('https://hust.media/truyenthanh/live/getswitch.php')
            .then((response) => {
                setlinklive(response.data);
            })
            .catch((error) => {
                alert_error(error);
            });
    };

    useEffect(() => {
        // Kết nối tới server Socket.IO
        const newSocket = io('http://vip.tecom.pro:3021', {
            withCredentials: true,
        });

        // Bắt sự kiện khi kết nối thành công
        newSocket.on('connect', () => {
            console.log('Đã kết nối Socket.IO');
        });

        // Lưu trữ socket trong state
        setSocket(newSocket);

        // Cleanup khi component bị unmounted
        return () => {
            newSocket.disconnect();
        };
    }, []); // Chỉ chạy một lần sau khi component được render
    const navigate = useNavigate();

    const submit = (value) => {
        sendUpdateLiveCommand(value);
        setnutxuly(1);
        setIsDisabled(true);
        setnutorder('Đợi xíu nhé');
        const myCookieValue = Cookies.get('apikey');
        let data = JSON.stringify({
            "service": value,
            "apikey": myCookieValue
        });
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://tecom.pro/truyenthanh/live/change_switch.php',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };
        axios.post(config.url, config.data, config.headers)
            .then((response) => {
                laydulieu();
                setnutxuly(0);
                alert_success('Thay đổi thành công');
                setnutorder('xác nhận');
                setIsDisabled(false);
            })
            .catch((error) => {
                setnutxuly(0);
                setnutorder('Thử lại');
                alert_error(error);
                setIsDisabled(false);
            });

    };
    function switch_router(link) {
        if (link) {
            navigate(link);
        }
    };
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;

        setnutxuly(0);

        if (status == 1) {
            setnutorder('Cảm ơn bạn đã ủng hộ');
            alert_success(message);
        }
        else if (status == 0) {
            alert_error(message);
        }
        else {
            setnutorder('Đã xảy ra lỗi vui lòng nhập lại');
            alert_error('Đã xảy ra lỗi vui lòng nhập lại');
        }
        setnutorder('xác nhận');
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }
    };
    return (
        <>
            <div className="w-full p-4">

                <table className="w-full border shadow-lg rounded-lg">
                    <thead className="bg-blue-500 text-white">
                        <tr className="lg:hidden">
                            <th className="border px-6 py-2 w-3/5 items-center justify-between text-center">Tên thiết bị</th>
                            <th className="border px-3 py-2 w-1/5">Trạng thái</th>
                            <th className="border px-3 py-2 w-1/5">Xác nhận</th>
                        </tr>
                        <tr className="hidden lg:table-row">
                            <th className="border px-6 py-2 w-3/5 items-center justify-between text-center">Tên thiết bị</th>
                            <th className="border px-3 py-2 w-1/5">Trạng thái</th>
                            <th className="border px-3 py-2 w-1/5">Xác nhận</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tasks.map((task) => (
                            <tr
                                key={task.id}
                                className={`hover:bg-gray-100 ${task.id == linklive ? 'bg-black text-white' : ''}`}
                            >

                                <td className="border px-6 py-3 lg:w-2/5 px-3 py-2">
                                    <div className="text-center flex items-center justify-between flex-1">
                                        <span className="mx-auto">{task.name}{task.id ==
                                            linklive && (<> (Đang chọn)</>)} </span>
                                    </div>
                                </td>
                                <td className="border px-6 py-3 lg:w-2/5 px-3 py-2">{task.gift}</td>
                                <td className="border  text-center">
                                    <button
                                        disabled={isDisabled}
                                        onClick={() => submit(task.id)}
                                        className="group rounded-2xl h-12 w-55 bg-pink-300 font-bold text-base text-white relative overflow-hidden"
                                    >
                                        {nutxuly == 1 && (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        )}
                                        {nutorder}
                                        <div className="absolute duration-300 inset-0 w-full h-full transition-all scale-0 group-hover:scale-100 group-hover:bg-white/30 rounded-2xl"></div>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

            </div>
        </>

    );
};

export default TaskList;
